interface CsvDownloadProps {
  data: any[];
  filename?: string;
  delimiter?: string;
  headers?: string[];
}

export const csvGenerateRow = (row: any, headerKeys: string[], delimiter: string) =>
  headerKeys
    .map((fieldName) =>
      typeof row[fieldName] === "number" ? row[fieldName] : `"${String(row[fieldName]).replace(/"/g, '""')}"`,
    )
    .join(delimiter);

export const csvGenerate = (data: any[], headers: string[] | undefined, delimiter: string) => {
  const headerKeys = Object.keys(data[0]);
  const columnNames = headers ?? headerKeys;
  const csv = data.map((row) => csvGenerateRow(row, headerKeys, delimiter));

  csv.unshift(columnNames.join(delimiter));

  return csv.join("\r\n");
};

const triggerCsvDownload = (csvAsString: string, fileName: string) => {
  // BOM support for special characters in Excel
  const byteOrderMark = "\uFEFF";

  const blob = new Blob([byteOrderMark, csvAsString], {
    type: "text/csv;charset=utf-8;",
  });

  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = fileName;
  link.style.display = "none";
  document.body.append(link);
  link.click();
  link.remove();
};

const csvDownload = ({ data, filename = "export.csv", delimiter = ";", headers }: CsvDownloadProps): void => {
  const formattedFilename = filename;

  if (data.length === 0) {
    triggerCsvDownload(headers ? headers.join(delimiter) : "", formattedFilename);
    return;
  }

  const csvAsString = csvGenerate(data, headers, delimiter);

  triggerCsvDownload(csvAsString, formattedFilename);
};

export default csvDownload;
